<ng-template #loadingGeneral>

  <mat-spinner class="center center"></mat-spinner>
  <h3 class="center center">Loading...</h3>

</ng-template>

<ng-template #loadingItem>
  <mat-progress-bar class="center" mode="indeterminate"></mat-progress-bar>
</ng-template>

<mat-menu #news="matMenu" class="h-max-75-vh w-min-40-vw" fxLayout="column" fxLayoutAlign="center stretch">

  <div class="">
    <h2 class="mb-0 w-100 text-center">Notifications</h2>
  </div>

  <ng-container *ngIf="!loading else loadingGeneral">

    <mat-list class="h-max-50-vh overflow-x-hidden">

      <ng-container *ngFor="let notification of notifications; let i = index">
        <mat-list-item class="notification-mat-list-item"
          (click)="notificationsToDismiss.push(notification);$event.stopPropagation();markAsRead(notificationsToDismiss)">
          <div fxLayout="column" fxLayoutAlign="start" class="pv-2_5 w-100">
            <div>
              <small>
                <i *ngIf="!notification.isRead" class="fas fa-circle fa-xs color-primary"></i>
                <strong>
                  {{notification.title}}
                </strong>
              </small>
            </div>
            <div class="multi-line" fxFlexOffset="1">
              <small>{{notification.message}}
              </small>
            </div>
            <div fxFlexOffset="1">
              <small>
                <i class="far fa-xs fa-clock"></i>
                {{notification.createdAt | date: "dd/MM/yyyy HH:mm"}}
              </small>
            </div>
          </div>
        </mat-list-item>
        <mat-divider class="mh-5"></mat-divider>
      </ng-container>
    </mat-list>

    <ng-container *ngIf="!noMoreNotifications">
      <button (click)="loadMoreNotifications();$event.stopPropagation()" *ngIf="!loadingMore else loadingItem"
        class="w-100 text-center" mat-button>
        <small>Load more</small>
      </button>
    </ng-container>

    <button (click)="markAsRead(notifications)" *ngIf="badgeNumber !== 0" class="w-100" color="primary" mat-button>
      <small>Mark all as read</small>
    </button>

  </ng-container>

</mat-menu>

<button (onMenuClose)="saveNotificationsMarkedAsRead()" [mat-menu-trigger-for]="news" color="light" fxFlexOffset="1"
  mat-icon-button>
  <mat-icon [matBadge]="badgeNumber" matBadgeColor="accent">notifications</mat-icon>
</button>
